"use strict";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var isInStandaloneMode = function isInStandaloneMode() {
  return window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone;
};

function isMobileOrTablet() {
  var check = false;

  (function (a) {
    if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true;
  })(navigator.userAgent || navigator.vendor || window.opera);

  return check;
}

;
var terms;
$.getJSON("/assets/lang/terms.json", function (data) {
  terms = data;
});
var currentStep = 'step1';

var Quote =
/*#__PURE__*/
function () {
  function Quote(obj) {
    _classCallCheck(this, Quote);

    this.id = 0;
    this.shapeid = "";
    this.shapename = "";
    this.materialid = "";
    this.materialname = "";
    this.materialcost = 0;
    this.quantity = 0;
    this.dimensions = "";
    this.cutlength = 0;
    this.cutcost = 0;
    this.cutspeed = 0;
    this.runtime = 0;
    this.machiningcost = 0; //run cost per part

    this.partlength = 0;
    this.partwidth = 0;
    this.partarea = 0.00;
    this.markup = 1.00;
    this.partmaterialcost = 0;
    this.costeach = 0;
    this.totalcost = 0;
    this.user = {};
    this.type = "quote";

    for (var prop in obj) {
      this[prop] = obj[prop];
    }

    if (this.id == 0) {
      this.id = this.getid();
    }
  }

  _createClass(Quote, [{
    key: "getid",
    value: function getid() {
      if (!Date.now) {
        Date.now = function () {
          return new Date().getTime();
        };
      }

      return Math.floor(Date.now() / 1000);
    }
  }, {
    key: "calculate",
    value: function calculate() {
      this.cutlength = 0;

      if (this.quantity > 0 && this.cutcost > 0 && this.cutspeed > 0 && this.materialcost > 0) {
        if (typeof this.dimensions["OD"] !== 'undefined') {
          //it's a circle
          this.cutlength += parseFloat(this.dimensions["OD"]["measurement"]) * Math.PI;
          this.partlength = this.dimensions["OD"]["measurement"];
          this.partwidth = this.dimensions["OD"]["measurement"];
        }

        if (typeof this.dimensions["ID"] !== 'undefined') {
          this.cutlength += parseFloat(this.dimensions["ID"]["measurement"]) * Math.PI;
        }

        if (typeof this.dimensions["HD"] !== 'undefined') {
          var qty = 4; //shape 3 has fixed # of holes

          if (typeof this.dimensions["HQ"] !== 'undefined') {
            qty = parseInt(this.dimensions["HQ"]["measurement"]);
          }

          this.cutlength += parseFloat(this.dimensions["HD"]["measurement"]) * Math.PI * qty;
        }

        if (typeof this.dimensions["TL"] !== 'undefined') {
          this.cutlength += parseFloat(this.dimensions["TL"]["measurement"] * 2 + parseFloat(this.dimensions["TW"]["measurement"]) * 2);
          this.partlength = this.dimensions["TL"]["measurement"];
          this.partwidth = this.dimensions["TW"]["measurement"];
        }

        if (typeof this.dimensions["ETD"] !== 'undefined') {
          this.cutlength += parseFloat(this.dimensions["ETD"]["measurement"]) * 4;
          this.partlength = this.dimensions["ETD"]["measurement"];
          this.partwidth = this.dimensions["ETD"]["measurement"];
        }

        if (typeof this.dimensions["ITD"] !== 'undefined') {
          //if(this.dimensions["HS"] == 'Square') {
          this.cutlength += parseFloat(this.dimensions["ITD"]["measurement"]) * 4; //} else {

          this.cutlength += parseFloat(this.dimensions["ITD"]["measurement"]) * Math.PI; //}
        }

        if (typeof this.dimensions["ITL"] !== 'undefined') {
          this.cutlength += parseFloat(this.dimensions["ITL"]["measurement"] * 2 + parseFloat(this.dimensions["ITW"]["measurement"]) * 2);
        } //we have cutlenght


        this.runtime = this.cutlength * 1.25 / this.cutspeed / 60;
        this.machiningcost = this.runtime * this.cutcost;
        this.partarea = this.partlength * this.partwidth * 1.3 / 1000000;
        this.partmaterialcost = this.materialcost * this.markup * this.partarea;
        this.costeach = this.machiningcost + this.partmaterialcost + 30 / this.quantity;

        if (this.costeach < 0.18) {
          this.costeach = 0.18;
        } else {
          this.costeach = parseFloat(Math.round(this.costeach * 100) / 100).toFixed(2);
        }

        if (this.costeach * this.quantity > 100) {
          this.costeach = parseFloat(this.costeach * 0.85).toFixed(2);
        }

        this.totalcost = this.costeach * this.quantity;
        this.quotedcost = parseFloat(Math.round(this.totalcost * 100) / 100).toFixed(2);
      } else {
        this.totalcost = 0;
        this.quotedcost = 0;
        this.costeach = 0;
      }
    }
  }]);

  return Quote;
}();

var myQuote;
$(function () {
  $(window).on('hashchange', function (e) {
    if (location.hash != '#' + currentStep) {
      console.log(location.hash);

      switch (location.hash) {
        case '#step1':
          hideAll();
          showShapes();
          break;

        case '#step2':
          hideAll();
          showDimensions();
          break;

        case '#step3':
          hideAll();
          showMaterial();
          break;

        case '#step4':
          hideAll();
          showSaveSubmit();
          break;
      }
    }
  });

  if (typeof myQuote === 'undefined') {
    myQuote = new Quote();
  }

  if (window.location.hash == "#retrieve") {
    retrieveQuotes();
  }

  if (window.location.hash.substr(0, 9) == "#summary-") {
    retrieveQuotes();
  }

  if ($('#content-area').length == 1) {
    var isSmallerThan = function isSmallerThan(inner, outer) {
      var inner_val = parseInt($(inner).val());
      var outer_val = parseInt($(outer).val());

      if (inner_val > 0) {
        if (outer_val > 0) {
          if (inner_val >= outer_val) {
            return false;
          } else {
            return true;
          }
        } else {
          return true;
        }
      } else {
        return true;
      }
    };

    var readFile = function readFile(file, filename, id) {
      var reader = new FileReader();
      reader.onload = readSuccess;

      function readSuccess(event) {
        localStorage.setItem(filename, event.target.result);

        if (localStorage.getItem(filename) === null) {
          $("label[for='file" + id + "-label']").addClass('storageerror');
          $('#file' + id).val('');
        }

        console.log(filename + " saved");
      }

      ;
      reader.readAsDataURL(file);
    };

    $('.intro').on('click', '.start', function () {
      $('#browse').removeClass('hide');
      $('.hide-for-large.intro').addClass('hide');
      $('#homelink').removeClass('hide');
      $('#saved').addClass('hide');
      showShapes();
    });

    if ($('#shapes').css('visibility') == 'visible') {
      showShapes();
    }

    ;
    $('body').on('click', '.retrieve-quote', function (event) {
      //event.preventDefault();
      retrieveQuotes();
    });
    $('#shapes').on('click', '.shape-button', function () {
      //restart quote with a new shape
      myQuote = new Quote();
      myQuote.shapeid = $(this).attr('data-shape-id');
      myQuote.shapename = $(this).attr('data-shape-name');
      updateQuote();
      $('#shapes').addClass('hide');
      showDimensions();
    });
    $('#materials').on('click', '.button', function () {
      myQuote.dimensions['T'] = {
        name: 'Thickness (mm)',
        measurement: $('#material-thickness').val()
      };

      if ($(this).hasClass('back')) {
        $('#materials').addClass('hide');
        showDimensions();
        return;
      }

      var valid = true;
      $('#materials .required').removeClass('error');
      $('#materials').find('select, input, textarea').each(function (i, obj) {
        if ($(this).hasClass('required')) {
          var value = $(this).val();

          if (value == "") {
            $("label[for='" + $(this).attr('id') + "']").addClass('error');
            valid = false;
          } else {
            if ($(this).attr('data-type') == "int") {
              if (isNaN(parseInt(value) == true) || parseInt(value) < 1) {
                $("label[for='" + $(this).attr('id') + "']").addClass('error');
                valid = false;
              }
            }
          }
        }
      });

      if (valid) {
        myQuote.materialid = $('#material-type').val();
        myQuote.materialname = $('#material-type option:selected').text();
        myQuote.notes = $('#materials #notes').val();
        myQuote.quantity = parseInt($('#quantity').val());
        updateQuote();
        $('#materials').addClass('hide');
        $.get('/material/specifications', function (data) {
          if (myQuote.shapeid != 7) {
            $.each(data.specs, function (index, value) {
              if (value.material_id == myQuote.materialid && parseFloat(value.thickness) == parseFloat(myQuote.dimensions["T"]["measurement"])) {
                myQuote.cutspeed = parseFloat(value.cut_speed);
                myQuote.materialcost = parseFloat(value.material_cost);
                myQuote.cutcost = parseFloat(value.cut_cost);
              }
            });
          }
        }).done(function () {
          updateQuote();
          showQuote();
        });
      }
    });
    $('#dimensions').on('click', '.button', function () {
      if ($(this).hasClass('back')) {
        $('#dimensions').addClass('hide');
        showShapes();
        return;
      }

      var valid = true;
      $('#dimensions .required').removeClass('error');
      $('#dimensions').find('select, input, textarea').each(function (i, obj) {
        if ($(this).hasClass('required')) {
          if ($(this).val() == "") {
            $("label[for='" + $(this).attr('id') + "']").addClass('error');
            valid = false;
          }
        }
      });

      if ($('#dimensions .dimension-error, #dimensions .max-error').length > 0) {
        valid = false;
      }

      if (valid) {
        var setdimensions = $("input[name*='dimension'], select[name*='dimension'], textarea[name*='dimension']");
        var set = {};
        $.each(setdimensions, function (index, value) {
          if ($(this).attr('id') != 'T') {
            var val = $(this).val();

            if ($(this).attr('data-type') == "int") {
              val = parseInt($(this).val());
            } else if ($(this).attr('data-type') == "float") {
              val = parseFloat($(this).val()).toFixed(2);
            }

            set[$(this).attr('id')] = {
              name: $(this).attr('data-desc'),
              measurement: val
            };
          }
        });
        myQuote.dimensions = set;
        updateQuote();
        $('#dimensions').addClass('hide');
        showMaterial();
      }
    });
    $('#total').on('click', '.back', function () {
      hideAll();
      showMaterial();
    });
    $('#total').on('click', '.next', function () {
      hideAll();
      showSaveSubmit();
    });
    $('#summary').on('click', '.submit', function () {
      if (submitQuote()) {
        $('#summary').addClass("hide");
        $('#final').removeClass("hide");
      }
    });
    $('#summary').on('click', '.pay', function () {
      saveQuote();
      myQuote.type = "order";
      submitQuote(true);
    });
    $('#summary').on('click', '.save', function () {
      saveQuote();
      $('#summary').addClass("hide");
      $('#final').removeClass("hide");
      $('#final .result').html(terms['saved']);
    });
    $('#summary').on('click', '.back', function () {
      showMaterial();
      $('#summary').addClass("hide");
    });
    $('#materials').on('change', '.customerfiles', function (event) {
      var types = ['image/png', 'image/jpeg', 'image/gif', 'application/pdf']; //TODO, somehting with file

      if (!types.includes(event.target.files[0].type)) {
        $("label[for='" + $(this).attr('id') + "']").addClass('typeerror');
        $(event.target).val(''); //remove file.

        return false;
      }

      if (event.target.files[0].size > 1000000) {
        $("label[for='" + $(this).attr('id') + "']").addClass('sizeerror');
        $(event.target).val('');
        return false;
      }

      saveQuote();
      var filename = myQuote.id + "-" + $(this).attr('id');
      readFile(event.target.files[0], filename, $(this).attr('id')); //CHECK FILE SIZE

      $("label[for='" + $(this).attr('id') + "']").addClass('success');
    });
    $('#materials').on('click', '.remove', function (event) {
      if ($(this).hasClass('file1')) {
        localStorage.removeItem(myQuote.id + '-file1');
        $('#materials .file1name').html('');
      }

      if ($(this).hasClass('file2')) {
        localStorage.removeItem(myQuote.id + '-file2');
        $('#materials .file2name').html('');
      }
    });
    $('#saved').on('click', '.quotelist .edit', function () {
      myQuote = new Quote(JSON.parse(localStorage.getItem('quote-' + $(this).attr('id'))));
      hideAll();
      updateQuote();
      showSaveSubmit();
    });
    $('#dimensions').on('change', 'input', function () {
      var id = $(this).attr('id');
      var val = $(this).val();
      var outer = null;

      switch (id) {
        case 'ID':
          if (isSmallerThan('#ID', '#OD')) {
            $("label[for='" + id + "']").removeClass('dimension-error');
          } else {
            $("label[for='" + id + "']").addClass('dimension-error');
          }

          $('#PCD').trigger('change');
          break;

        case 'ITL':
          if (isSmallerThan('#ITL', '#TL')) {
            $("label[for='" + id + "']").removeClass('dimension-error');
          } else {
            $("label[for='" + id + "']").addClass('dimension-error');
          }

          break;

        case 'ITW':
          if (isSmallerThan('#ITW', '#TW')) {
            $("label[for='" + id + "']").removeClass('dimension-error');
          } else {
            $("label[for='" + id + "']").addClass('dimension-error');
          }

          break;

        case 'OD':
          if (parseFloat(val) > 1000) {
            $("label[for='" + id + "']").addClass('max-error');
          } else {
            $("label[for='" + id + "']").removeClass('max-error');
          }

          $('#ID').trigger('change');
          break;

        case 'TL':
          if (parseFloat(val) > 1000) {
            $("label[for='" + id + "']").addClass('max-error');
          } else {
            $("label[for='" + id + "']").removeClass('max-error');
          }

          $('#ITL').trigger('change');
          break;

        case 'TW':
          if (parseFloat(val) > 1000) {
            $("label[for='" + id + "']").addClass('max-error');
          } else {
            $("label[for='" + id + "']").removeClass('max-error');
          }

          $('#ITW').trigger('change');
          break;

        case 'PCD':
          if (isSmallerThan('#ID', '#PCD') && isSmallerThan('#PCD', '#OD')) {
            $("label[for='" + id + "']").removeClass('dimension-error');
          } else {
            $("label[for='" + id + "']").addClass('dimension-error');
          }

          break;

        case 'HD':
          $("label[for='" + id + "']").removeClass('dimension-error');
          var hr = parseInt($(this).val());

          if (hr > 0) {
            var inner = parseInt($('#ID').val());
            var outer = parseInt($('#OD').val());
            var pcd = parseInt($('#PCD').val());

            if (pcd > 0) {
              if (inner > 0) {
                if (inner > pcd - hr) {
                  $("label[for='" + id + "']").addClass('dimension-error');
                }
              }

              if (outer > 0) {
                if (outer < pcd + hr) {
                  $("label[for='" + id + "']").addClass('dimension-error');
                }
              }
            }
          }

          break;
      }
    });
    $('#material-type').on('change', function () {
      myQuote.materialid = $(this).val();
      myQuote.materialname = $('option:selected', this).text();
      $('#material-thickness').children().remove();
      $.get('/material/specifications', function (data) {
        $('#material-thickness').append($('<option>', {
          value: "",
          text: "Choose..."
        }));
        $.each(data.specs, function (index, value) {
          if (value.material_id == myQuote.materialid) {
            $('#material-thickness').append($('<option>', {
              value: value.thickness,
              text: value.thickness + 'mm'
            }));
          }
        });

        if (typeof myQuote.dimensions["T"] != 'undefined') {
          $('#material-thickness').val(myQuote.dimensions["T"]["measurement"]);

          if ($('#material-thickness').val() != myQuote.dimensions["T"]["measurement"]) {
            $('#material-thickness').val('');
          }

          $('#material-thickness').trigger('change');
        }

        updateQuote();
      });
    });
    $('#material-thickness').on('change', function () {
      myQuote.dimensions['T'] = {
        name: 'Thickness (mm)',
        measurement: $(this).val()
      };
      myQuote.cutspeed = 0;
      myQuote.material_cost = 0;
      myQuote.cut_cost = 0;
      var thickness = $(this).val();
      $("label[for='material-thickness']").removeClass('dimension-error');

      if (typeof myQuote.dimensions['ID'] != 'undefined') {
        var flange = myQuote.dimensions['OD'].measurement - myQuote.dimensions['ID'].measurement;
        console.log('t', thickness, 'fr', flange);

        if (thickness > flange) {
          $("label[for='material-thickness']").addClass('dimension-error');
        }

        if (typeof myQuote.dimensions['PCD'] != 'undefined') {
          var pcd = myQuote.dimensions['PCD'].measurement;
          var hr = myQuote.dimensions['HD'].measurement / 2;
          var outer_flange = myQuote.dimensions['OD'].measurement - pcd - hr;
          var inner_flange = pcd - hr - myQuote.dimensions['ID'].measurement;
          console.log('pcd', pcd, 'hr', hr, 'of', outer_flange, 'if', inner_flange);

          if (thickness > outer_flange) {
            $("label[for='material-thickness']").addClass('dimension-error');
          }

          if (thickness > inner_flange) {
            $("label[for='material-thickness']").addClass('dimension-error');
          }
        }
      }

      if (typeof myQuote.dimensions['ITL'] != 'undefined') {
        var flange = myQuote.dimensions['TL'].measurement - myQuote.dimensions['ITL'].measurement;
        console.log('t', thickness, 'fl', flange);

        if (thickness > flange) {
          $("label[for='material-thickness']").addClass('dimension-error');
        }
      }

      if (typeof myQuote.dimensions['ITW'] != 'undefined') {
        var flange = myQuote.dimensions['TW'].measurement - myQuote.dimensions['ITW'].measurement;
        console.log('t', thickness, 'fw', flange);

        if (thickness > flange) {
          $("label[for='material-thickness']").addClass('dimension-error');
        }
      }

      $.get('/material/specifications', function (data) {
        if (myQuote.shapeid != 7) {
          $.each(data.specs, function (index, value) {
            if (value.material_id == myQuote.materialid && parseFloat(value.thickness) == parseFloat(myQuote.dimensions["T"]["measurement"])) {
              myQuote.cutspeed = parseFloat(value.cut_speed);
              myQuote.materialcost = parseFloat(value.material_cost);
              myQuote.cutcost = parseFloat(value.cut_cost);
            }
          });
        }

        updateQuote();
      });
    });
    $('#quantity').on('keypress keyup blur change', function () {
      myQuote.quantity = parseInt($(this).val());
      updateQuote();
    });
  }
});

function retrieveQuotes() {
  hideAll();
  $('#shapes').css('visibility', 'hidden');
  $('.hide-for-large.intro').addClass('hide');
  $('#quote .empty').removeClass('hide');
  $('#quote .summary').addClass('hide');
  $('#saved').removeClass('hide');
  showSavedQuotes();
}

function showSaveSubmit() {
  //update info if custom
  if ($('#total').hasClass('custom')) {
    myQuote.shapeid = 7;
    myQuote.shapename = "custom";
    myQuote.notes = $('#materials #notes').val();
  }

  if (isOnline() == false) {
    //if offline, save quote in local storage
    $('#total').addClass('hide');
    saveQuote();
    $('#summary .detail').empty();
    $('#summary').removeClass('hide');
    $('#summary .detail').append(terms['offline']);
    $('#summary .offline').removeClass('hide');
    $('#summary .online').addClass('hide');
  } else {
    $('#total').addClass('hide');
    saveQuote(); //save it whatever so we can go back

    $('#summary .detail').empty();
    $('#summary').removeClass('hide');
    $('#summary .online').removeClass('hide');
    $('#summary .offline').addClass('hide');
    $('#summary #save').addClass('hide');
    var evaluatetext = terms['evaluate'];
    var pricetext = terms['quoteprice'].replace('@@priceeach@@', myQuote.costeach).replace('@@priceeach@@', myQuote.costeach).replace('@@quotecost@@', myQuote.quotedcost);

    if (isNaN(myQuote.totalcost)) {
      $('#quote .price').html(evaluatetext);
      $('#summary #submit, #summary .submit').removeClass('hide');
      $('#summary #pay, #summary .pay').addClass('hide');
    } else {
      if (myQuote.quotedcost > maxOrderValue) {
        $('#quote .price').html(terms['maxorder'].replace('@@maxorder@@', maxOrderValue));
        $('#summary #submit, #summary .submit').removeClass('hide');
        $('#summary #pay, #summary .pay').addClass('hide');
      } else {
        if (myQuote.shapeid == 3 || myQuote.shapeid == 7) {
          $('#quote .price').html(pricetext + evaluatetext);
          $('#summary #submit, #summary .submit').removeClass('hide');
          $('#summary #pay, #summary .pay').addClass('hide');
        } else {
          $('#quote .price').html(pricetext);
          $('#summary #submit, #summary .submit').removeClass('hide');
          $('#summary #pay, #summary .pay').removeClass('hide');
        }
      }
    }

    $('#summary .detail').append(terms['details']);
    $('#summary .detail').append('<div class="cell"><label for="name">Contact Name *</label><input type="text" name="name" id="name" class="required" required /></div>');
    $('#summary .detail').append('<div class="cell"><label for="email">Email *</label><input type="email" name="email" id="email" class="required" required /></div>');
    $('#summary .detail').append('<div class="cell"><label for="telephone">Contact Telephone *</label><input type="text" name="telephone" id="telephone" class="required" required /></div>');
    $('#summary .detail').append('<div class="cell"><label for="company">Company</label><input type="text" name="company" id="company" /></div>');
    $('#summary .detail').append('<div class="cell"><label for="town">Town/City</label><input type="text" name="town" id="town" /></div>');
    $('#summary #name').focus();
    currentStep = 'step4';
    window.location.hash = 'step4';
  }
}

function hideAll() {
  //$('.intro').addClass('hide');
  $('#shapes').addClass('hide');
  $('#materials').addClass('hide');
  $('#dimensions').addClass('hide');
  $('#total').addClass('hide');
  $('#summary').addClass('hide');
  $('#final').addClass('hide'); //$('#quote .empty').removeClass('hide');
  //$('#quote .summary').addClass('hide');

  $('#saved').addClass('hide');
}

function isOnline() {
  if (navigator.onLine) {
    console.log("online");
    return true;
  }

  console.log("offline");
  return false;
}

function saveQuote() {
  localStorage.setItem('quote-' + myQuote.id, JSON.stringify(myQuote));
}

function updateQuote() {
  myQuote.calculate();
  updateOverview();
}

function updateOverview() {
  $('#quote .quote-shape span').text(myQuote.shapename);
  $('#quote .quote-shape-image').attr('src', '/assets/images/shapes/gasket-shape-' + myQuote.shapeid + '.jpg');
  $('#quote .quote-material span').text(myQuote.materialname);

  if (typeof myQuote.dimensions['T'] != 'undefined') {
    $('#quote .quote-material-thickness span').text(myQuote.dimensions['T']['measurement']);
  }

  $('#quote .quote-quantity span').text(myQuote.quantity);
  $('#quote .quote-notes span').text(myQuote.notes);
  var dims = "";
  $.each(myQuote.dimensions, function (index, value) {
    if (index != 'T') {
      dims += value['name'] + ": " + value['measurement'] + "<br />";
    }
  });
  $('#quote .quote-dimensions span').html(dims);

  if (!isNaN(myQuote.totalcost) && myQuote.totalcost > 0) {
    if (myQuote.quotedcost > maxOrderValue) {
      $('#quote .price, #materials .price').html(terms['maxorder'].replace('@@maxorder@@', maxOrderValue));
    } else {
      $('#quote .price, #materials .price').html(terms['quoteprice'].replace('@@priceeach@@', myQuote.costeach).replace('@@priceeach@@', myQuote.costeach).replace('@@quotecost@@', myQuote.quotedcost));
    }
  } else if ($('#material-type').val() == '' || $('#material-thickness').val() == '') {
    $('#quote .price, #materials .price').html('');
  }

  $('#quote .empty').addClass('hide');
  $('#quote .summary').removeClass('hide');
}

function showQuote() {
  myQuote.calculate();
  hideAll();
  $('#total .detail').empty();

  if (isOnline()) {
    $('#total .submit').removeClass('hide');
  } else {
    $('#total .submit').addClass('hide');
  } //$('#total').removeClass('hide');


  $('#total .detail').append('<div class="grid-x">');

  if (isNaN(myQuote.totalcost)) {
    $('#total .detail').append('<div class="cell">' + terms['cannotquote'] + '</div>');
    $('#quote .price').html(terms['cannotquote']);
  } else {
    if (myQuote.quotedcost > maxOrderValue) {
      $('#quote .price').html(terms['maxorder'].replace('@@maxorder@@', maxOrderValue));
      $('#total .detail').html('<div class="cell"><p>' + terms['maxorder'].replace('@@maxorder@@', maxOrderValue) + '</p></div>');
    } else {
      $('#total .detail').append('<div class="cell"><p>' + terms['quoteprice'].replace('@@priceeach@@', myQuote.costeach).replace('@@priceeach@@', myQuote.costeach).replace('@@quotecost@@', myQuote.quotedcost) + '</p><p>' + terms['submit'] + '</p></div>');
      $('#quote .price').html(terms['quoteprice'].replace('@@priceeach@@', myQuote.costeach).replace('@@priceeach@@', myQuote.costeach).replace('@@quotecost@@', myQuote.quotedcost));
    }
  }

  $('#total .detail').append('</div>');
  $('#total label').removeClass('success').removeClass('typeerror').removeClass('sizeerror').removeClass('storageerror');
  showSaveSubmit();
}

function showSavedQuotes() {
  var quotes = [];

  for (var key in localStorage) {
    if (key.substr(0, 5) == "quote") {
      quotes.push(new Quote(JSON.parse(localStorage.getItem(key))));
    }
  } //$('#saved .count').html("<p>You have " + quotes.length + " saved quotes</p>");


  $('#saved .quotelist').empty();
  $.each(quotes, function (index, value) {
    var quotedate = new Date(value.id * 1000);
    $('#saved .quotelist').append('<div class="cell"><small>' + quotedate.toLocaleString() + '</small> - ' + ': ' + value.shapename + ' - ' + value.materialname + ' - ' + value.quantity + '<a href="#" class="edit" id="' + value.id + '"> Load</a></div><div class="cell"><hr /></div>');
  });
}

function submitQuote() {
  var pay = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  //check user info is all there
  var valid = true;
  $('#summary').find('input').each(function (i, obj) {
    $("label[for='" + $(this).attr('id') + "']").removeClass('error').removeClass('email-error');

    if ($(this).hasClass('required')) {
      var value = $(this).val();

      if (value == "") {
        $("label[for='" + $(this).attr('id') + "']").addClass('error');
        valid = false;
      }
    }

    if ($(this).attr('type') == 'email' && $(this).val() != '') {
      if (!$(this).val().match(/^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+$/)) {
        $("label[for='" + $(this).attr('id') + "']").addClass('email-error').removeClass('error');
        valid = false;
      }
    }

    myQuote.user[$(this).attr('id')] = $(this).val();
  });

  if (valid == true) {
    var promise = saveQuoteDetail(pay);
    var file1 = localStorage.getItem(myQuote.id + "-file1");
    var file2 = localStorage.getItem(myQuote.id + "-file2");
    promise.then(function (result) {
      return cleanUp(result, pay);
    }, function (error) {
      saveError();
    });
  }
}

function saveError() {
  saveQuote(), $('#summary').addClass("hide");
  $('#final').removeClass("hide");
  $('#final .result').html(terms['cannotsend']);
}

function cleanUp(ref, pay) {
  $('#final .result').html(terms['quotesent'].replace('@@ref@@', ref));
  localStorage.removeItem(myQuote.id + "-file1");
  localStorage.removeItem(myQuote.id + "-file2");
  localStorage.removeItem("quote-" + myQuote.id);

  if (pay == true) {
    window.location = "/pay/detail/" + ref;
  } else {
    $('#summary').addClass("hide");
    $('#final').removeClass("hide");
    $('#final .result').html(terms['quotesent'].replace('@@ref@@', ref));
  }
}

function saveQuoteDetail() {
  return new Promise(function (resolve, reject) {
    var file1 = localStorage.getItem(myQuote.id + "-file1");
    var file2 = localStorage.getItem(myQuote.id + "-file2");
    $.post('/quote/submit', {
      data: JSON.stringify(myQuote),
      f1: file1,
      f2: file2
    }).done(function (response) {
      if (response.status == "OK") {
        resolve(response.ref);
      } else {
        reject(new Error("Quote not saved!"));
      }
    }).fail(function () {
      reject(new Error("Quote could not be saved!"));
    });
  });
}

function showShapes() {
  $('#shapes').removeClass('hide');
  $('#shapes').css('visibility', 'visible');
  $('#quote .empty').addClass('hide');
  $('#quote .summary').removeClass('hide');
  $('#shapes .list').empty();
  $.get('/shape', function (data) {
    var shapelist = $('<div class="grid-x small-up-2 medium-up-3 grid-margin-x grid-margin-y"></h2>').appendTo('#shapes .list');
    $.each(data.shapes, function (index, value) {
      shapelist.append('<div class="cell"><img src="/assets/images/shapes/gasket-shape-' + index + '.jpg" class="shape-button" data-shape-id="' + index + '" data-shape-name="' + value + '" /><button type="button" class="button shape-button" data-shape-id="' + index + '" data-shape-name="' + value + '">' + value + '</button></div>');
    });
    $('#online').removeClass('hide');
  });
  currentStep = 'step1';
  window.location.hash = 'step1';
}

function showMaterial() {
  $('#material-thickness').trigger('change');
  $('#materials').removeClass('hide');
  $('#material-type').children().remove();
  $.get('/material', function (data) {
    //if($('#material-type').children('option').length == 1) {
    $('#material-type').append($('<option>', {
      value: "",
      text: "Choose..."
    }));
    $.each(data.materials, function (index, value) {
      $('#material-type').append($('<option>', {
        value: value.id,
        text: value.name
      }));
    });

    if (myQuote.shapeid == 7) {
      //only add "other" option for a custom shape
      $('#material-type').append($('<option>', {
        value: "other",
        text: "Other"
      }));
    } //}


    $('#material-type').val(myQuote.materialid);
    $('#material-type').focus();
  });
  $('#materials #quantity').val(myQuote.quantity);
  $('#materials #notes').val(myQuote.notes);

  if (localStorage.getItem(myQuote.id + "-file1") !== null) {
    $('#materials .file1name').html('<span style="font-weight:bold">file added</span> <a href="#" class="remove file1"><b>remove</b></a>');
  } else {
    $('#materials .file1name').html('');
  }

  if (localStorage.getItem(myQuote.id + "-file2") !== null) {
    $('#materials .file2name').html('<span style="font-weight:bold">file added</span> <a href="#" class="remove file2"><b>remove</b></a>');
  } else {
    $('#materials .file2name').html('');
  }

  $('#materials #file1').val('');
  $('#materials #file2').val('');

  if (localStorage.getItem(myQuote.id + "-file1") !== null) {
    $('#materials .file1name').html('<span style="font-weight:bold">file added</span> <a href="#" class="remove file1"><b>remove</b></a>');
  } else {
    $('#materials .file1name').html('');
  }

  if (localStorage.getItem(myQuote.id + "-file2") !== null) {
    $('#materials .file2name').html('<span style="font-weight:bold">file added</span> <a href="#" class="remove file2"><b>remove</b></a>');
  } else {
    $('#materials .file2name').html('');
  }

  if (isOnline) {
    $('.upload').removeClass('hide');
  } else {
    $('.upload').addClass('hide');
  }

  currentStep = 'step3';
  window.location.hash = 'step3';
}

function showDimensions() {
  $('#dimensions .list').empty(); //clear out any existing fields

  var focuselement = "";
  $.get('/shape/dimensions', function (data) {
    var info = data[myQuote.shapeid]; //get only shape stuff

    var fieldlist = $('<div class="grid-x grid-margin-x"></div>').appendTo('#dimensions .list');
    fieldlist.append('<div class="cell diagram"><img src="/assets/images/shapes/gasket-dimension-' + myQuote.shapeid + '.jpg" /></div>');
    $.each(info, function (index, value) {
      if (index != 'T') {
        var currentvalue = typeof myQuote['dimensions'][index] === 'undefined' ? '' : myQuote['dimensions'][index].measurement;
        fieldlist.append('<div class="medium-6 cell"><label for="' + index + '">' + value.title + '</label></div>');

        if (value.choice != "") {
          fieldlist.append('<div class="medium-6 cell"><select name="dimension[]" data-type="' + value.type + '" data-desc="' + value.title + '" id="' + index + '" /></select></div>');
          var select = $('#dimensions .list #' + index);
          $.each(value.choice, function (i, opt) {
            if (opt.id == 0) {
              select.append($('<option>', {
                value: opt.text,
                text: opt.text
              }));
            } else {
              //look for material
              if (opt.material_id == myQuote.materialid) {
                select.append($('<option>', {
                  value: opt.text,
                  text: opt.text
                }));
              }
            }
          });

          if (currentvalue != '') {
            $('#dimensions .list #' + index).val(currentvalue);
          } //$('#dimensions .list #' + index + ' option[value=' + currentvalue + ']').attr('selected', 'selected');

        } else {
          if (value.type == "longtext") {
            fieldlist.append('<div class="cell"><textarea ' + (value.required == 1 ? 'class="required" ' : '') + 'data-type="' + value.type + '" name="dimension[]" data-desc="' + value.title + '" id="' + index + '" placeholder="' + (value.letter == null ? "" : "(" + value.letter + ")") + '" rows="4">' + currentvalue + '</textarea></div>');
          } else {
            fieldlist.append('<div class="medium-6 cell"><input type="number" ' + (value.required == 1 ? 'class="required" ' : '') + 'data-type="' + value.type + '" name="dimension[]" data-desc="' + value.title + '" id="' + index + '" placeholder="' + (value.letter == null ? "" : "(" + value.letter + ")") + '" value="' + currentvalue + '" /></div>');
          }
        }

        if (focuselement == "") {
          focuselement = $('#dimensions #' + index);
        }
      }
    });
    $('#online, #dimensions').removeClass('hide');
    $(focuselement).select();
    currentStep = 'step2';
    window.location.hash = 'step2';
  });
}